import React from 'react';
import {View} from 'react-native';

import LoadingIndicator from '/component/base/LoadingIndicator';

import {styles} from './Loading.style';

export const Loading = () => (
  <View style={[styles.loading, styles.loadingSection]}>
    <LoadingIndicator />
  </View>
);
